/**
 * Main Theme JavaScript Include File
 */
// import Plyr from "plyr";
import "./components/editorial-intro";
import "./components/expander-box";
import "./components/issue-navigation";
import "./components/offcanvas";
import "./components/satisfaction-ratings";
import "./components/video-volume-toggle";

// const videoPlayer = new Plyr( ".js--player" );

/**
 * Setup Font Awesome
 */
window.FontAwesomeConfig = {
	searchPseudoElements: true
};

/**
 * Smooth Scroll to Anchor
 */
jQuery( function( $ ) {

	$( document ).on( "click", "a[href^=\"#\"]", function( event ) {
		event.preventDefault();

		$( "html, body" ).animate( {
			scrollTop: $( $.attr( this, "href" ) ).offset().top
		}, 100 );
	} );

} );

/**
 * Limit Looping for Hero Videos
 */
const videos       = document.querySelectorAll( ".js-limit-looping" );
const videosLength = videos.length;

if ( videos ) {

	for ( let index = 0; index < videosLength; index++ ) {
		let video = videos[index];

		let iteration   = 1;
		const loopLimit = ( video.dataset.looplimit ) ? parseInt( video.dataset.looplimit ):3;

		video.addEventListener( "ended", function() {
			if ( iteration < loopLimit ) {
				this.currentTime = 0;
				this.play();
				iteration++;
			}
		} );

	}
}
